<template>
	<div id="register-form" class="h-full">
		<div class="relative flex h-fit flex-col md:h-[600px]">
			<Transition key="1" name="fade" mode="out-in">
				<BusinessRegisterInterestForm
					v-if="
						!businessRegister.isInterestDataSubmitted &&
						!businessRegister.isCompanyInfoSubmitted
					"
					class="w-full"
				/>
			</Transition>
			<Transition key="2" name="fade" mode="out-in">
				<BusinessRegisterCompanyForm
					v-if="
						businessRegister.isInterestDataSubmitted &&
						!businessRegister.isCompanyInfoSubmitted
					"
					class="absolute bottom-0 left-0 right-0 top-0 w-full"
				/>
			</Transition>
			<Transition key="3" name="fade" mode="out-in">
				<div
					v-if="
						businessRegister.isInterestDataSubmitted &&
						businessRegister.isCompanyInfoSubmitted
					"
					class="absolute bottom-0 left-0 right-0 top-0 w-full"
				>
					<div class="h-fit p-0 md:p-10">
						<div
							class="flex h-full w-full items-center bg-gray-100 p-10 md:rounded-md"
						>
							<div>
								<h3 class="text-2xl">Thank you</h3>
								<p class="text-gray-700">
									We have received your interest and will be
									in touch shortly.
								</p>
							</div>
						</div>
					</div>
				</div>
			</Transition>
		</div>
	</div>
</template>

<script setup>
import BusinessRegisterInterestForm from '@/components/forms/hubspot/BusinessRegisterInterestForm.vue'
import BusinessRegisterCompanyForm from '@/components/forms/hubspot/BusinessRegisterCompanyForm.vue'
import { useBusinessRegister } from '@/stores/business-register-your-interest'

const businessRegister = useBusinessRegister()
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}
.fade-leave-active {
	@apply absolute left-0 w-full;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
